import { render, staticRenderFns } from "./smtp.vue?vue&type=template&id=d68f5ca8"
import script from "./smtp.vue?vue&type=script&lang=js"
export * from "./smtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports